import { Link } from 'react-router-dom';

// material-ui
import { Box, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import AuthWrapper1 from '../AuthWrapper1';
import AuthRegister from '../auth-forms/AuthRegister';
import ImageSilla from 'assets/images/auth/silla.png';

// ===============================|| AUTH3 - REGISTER ||=============================== //

const Register = () => {
    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <AuthWrapper1 sx={{ overflow: 'hidden', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box
                sx={{
                    width: matchDownMD ? '95%' : '80%',
                    height: '90vh',
                    borderRadius: '2rem',
                    bgcolor: 'background.paper',
                    overflow: 'hidden',
                    display: 'flex'
                }}
            >
                <Grid container sx={{ flex: 1, height: '100%' }}>
                    {/* Left - Image panel */}
                    {!matchDownMD && (
                        <Grid
                            item
                            md={5}
                            sx={{
                                position: 'relative',
                                borderRadius: '2rem 0 0 2rem',
                                overflow: 'hidden',
                                height: '100%'
                            }}
                        >
                            <Box
                                component="img"
                                src={ImageSilla}
                                alt="Clínica dental"
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    display: 'block'
                                }}
                            />
                            {/* Blue overlay */}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    inset: 0,
                                    background: 'linear-gradient(180deg, rgba(30,90,150,0.35) 0%, rgba(20,60,120,0.65) 100%)'
                                }}
                            />
                            {/* Bottom text */}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    bottom: 40,
                                    left: 32,
                                    right: 32,
                                    color: '#fff'
                                }}
                            >
                                <Typography variant="h2" sx={{ color: '#fff', fontWeight: 700, mb: 1.5 }}>
                                    MedicalHealth
                                </Typography>
                                <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.88)', mb: 3, lineHeight: 1.6 }}>
                                    Únete a la plataforma de gestión clínica más avanzada. Diseñada para la precisión, creada para el
                                    cuidado.
                                </Typography>
                                {/* Pagination dots */}
                                <Stack direction="row" spacing={1}>
                                    <Box sx={{ width: 28, height: 4, bgcolor: '#fff', borderRadius: 2 }} />
                                    <Box sx={{ width: 10, height: 4, bgcolor: 'rgba(255,255,255,0.45)', borderRadius: 2 }} />
                                    <Box sx={{ width: 10, height: 4, bgcolor: 'rgba(255,255,255,0.45)', borderRadius: 2 }} />
                                </Stack>
                            </Box>
                        </Grid>
                    )}

                    {/* Right - Form panel */}
                    <Grid
                        item
                        xs={12}
                        md={7}
                        sx={{
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: { xs: 3, sm: 4, md: 5 },
                            overflow: 'hidden'
                        }}
                    >
                        <Box sx={{ width: '100%', maxWidth: 480 }}>
                            <Typography variant="h1" sx={{ fontWeight: 700, mb: 0.5 }}>
                                Crear Cuenta
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                                Crea tu cuenta y lleva la gestión de tu clínica al siguiente nivel.
                            </Typography>
                            <AuthRegister />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </AuthWrapper1>
    );
};

export default Register;
